// extracted by mini-css-extract-plugin
module.exports = {"radioGroupContainer":"questionAlertsTypeSwitcher_radioGroupContainer__eJonf","radioItemWrp":"questionAlertsTypeSwitcher_radioItemWrp__japPG"};